export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/tuner-icon.svg?38ebbe6eeb2d21b95c1e636954f2e1c9";